import { isAxiosError } from "axios";

import { ErrorMessage } from "@src/multiCustodian/components/TaxBudgets/reducer/types";

interface ApiErrorProps {
  error: unknown;
  errorMessage: string;
  genericErrorMessage: string;
  notify: (message: string, type: "Error") => void;
}

export const handleApiError = ({
  error,
  errorMessage,
  genericErrorMessage,
  notify,
}: ApiErrorProps) => {
  if (isAxiosError<ErrorMessage>(error)) {
    const message =
      typeof error.response?.data === "string"
        ? error.response.data
        : error.response?.data?.message ?? "";
    notify(`${errorMessage} ${message}`, "Error");
  } else {
    notify(genericErrorMessage, "Error");
  }
};
